import { Component, Input } from '@angular/core';

@Component({
  selector: 'rnpl-status-icon-tooltip',
  templateUrl: './status-icon-tooltip.component.html',
  styleUrls: ['./status-icon-tooltip.component.scss']
})
export class StatusIconTooltipComponent {
  @Input() visible = false;
  @Input() title: string;
  @Input() statusLabel: string;
  @Input() top = 0;
  @Input() left = 0;
  @Input() flipUp = false;
}
